<template>
  <div class="col-md-12 row mx-auto py-10">
    <div style="position: relative" class="pb-10 px-5">
      <v-carousel height="200" hide-delimiters>
        <template v-for="(item, index) in guidence.length">
          <v-carousel-item
            class="p-5"
            v-if="(index + 1) % columns === 1 || columns === 1"
            :key="index"
          >
            <v-row class="flex-nowrap">
              <template v-for="(n, i) in columns">
                <template v-if="+index + i < guidence.length">
                  <div
                    :class="
                      activeProject === guidence[index + i].value
                        ? 'col-md-2 text-center cardActive cardStyle my-4 mx-5'
                        : 'col-md-2 text-center cardStyle my-4 mx-5'
                    "
                    @click="
                      getPages(
                        guidence[index + i].sid,
                        guidence[index + i].value
                      )
                    "
                  >
                    <img :src="guidence[index + i].img" alt="" width="65" />
                    <p class="mt-4 font-weight-bold">
                      {{ guidence[index + i].name }}
                    </p>
                  </div>
                </template>
              </template>
            </v-row>
          </v-carousel-item>
        </template>
      </v-carousel>

      <div class="row mx-auto mt-5">
        <div class="col-md-3">
          <v-btn
            @click="goTo(x.id, x.slug)"
            :key="x.slug"
            v-for="(x, index) in pages"
            :class="
              isActive === x.slug
                ? 'font-weight-bold bg-indigo mb-2 col-md text-center btnActive rounded'
                : 'font-weight-bold btnStyles bg-white mb-2 col-md text-center rounded'
            "
            style="border-color: navy !important; letter-spacing: unset"
          >
            {{ x.name }}
          </v-btn>
        </div>
        <div class="col-md cardMine">
          <p>
            ۱۴۰۱© کلیه حقوق مادی و معنوی این سامانه محفوظ و متعلق به شرکت
            تبلیغاتی کارآفرینان برتر سپهر آراد می باشد ، هرگونه کپی برداری پیگرد
            قانونی دارد.
          </p>
        </div>
      </div>
      <v-speed-dial
        direction="top"
        absolute
        left
        bottom
        transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <v-btn dark fab bottom small color="indigo">
            <v-icon>call</v-icon>
          </v-btn>
        </template>
        <v-btn small class="text-white font-weight-bold" color="green">
          <v-icon class="ml-2">mdi-whatsapp</v-icon>
          ارتباط در واتساپ
        </v-btn>
        <v-btn small class="text-white px-5 font-weight-bold" color="primary">
          <v-icon class="ml-2">mdi-phone</v-icon>
          {{ "021-91017077" | persianNum }}
        </v-btn>
        <v-btn
          small
          class="text-white text-dark px-7 font-weight-bold"
          color="warning"
        >
          <v-icon class="ml-2">mdi-chat</v-icon>
          ثبت تیکت
        </v-btn>
      </v-speed-dial>
    </div>
  </div>
</template>
<script>
import { Axios2 } from "@/main";

export default {
  name: "etelaat",
  props: {
    sid: {
      default: 1,
    },
    activeProject: {
      default: "terminal",
    },
  },
  data() {
    return {
      tab: 0,
      isActive: "",
      guidence: [
        {
          name: "سامانه ترمینال تبلیغات",
          value: "terminal",
          sid: "1",
          img: require("@/assets/img/logo/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.webp"),
        },
        {
          name: "سامانه ارسال پیامک هدفمند",
          sid: "2",
          value: "sms",
          img: require("@/assets/img/logo/payamak-land.webp"),
        },
        {
          name: "سامانه مدیریت‌آگهی‌تبلیغاتی",
          value: "rbLand",
          sid: "4",
          img: require("@/assets/img/logo/robot-land.webp"),
        },
        {
          name: "سامانه بانک اطلاعات مشاغل کشور",
          value: "info",
          sid: "10",
          img: require("@/assets/img/logo/info-land.webp"),
        },
        {
          name: "سامانه مدیریت‌آنلاین فایل املاک",
          value: "realEstate",
          sid: "11",
          img: require("@/assets/img/logo/estate-land.webp"),
        },
        {
          name: "سامانه خدمات طراحی گرافیکی و ویدئو",
          value: "geraphic",
          sid: "14",
          img: require("@/assets/img/logo/graphic-land-mix.webp"),
        },
        {
          name: "سامانه طراحی،پشتیبانی و سئوسایت",
          value: "digi",
          sid: "13",
          img: require("@/assets/img/logo/web-land-1.webp"),
        },

        // {name: 'سامانه فروشگاه آنلاین شخصی', value: 'shopOnline'},
        // {name: 'سامانه تبلیغات در شبکه های اجتماعی', value: 'ads'},
        // {name: 'سامانه اجاره بیلبوردآنلاین', value: 'bilboard'},
        // {name: 'سامانه تبلیغات دررسانه های ملی', value: 'meli'},
        // {name: 'سامانه تبلیغات درناوگان حمل و نقل', value: 'transport'},
        // {name: 'سامانه تبلیغات دررسانه های تصویری', value: 'meliMedia'},
        // {name: 'سامانه مدیریت‌آنلاین فایل املاک', value: 'picMedia'},
        // {name: 'سامانه مدیریت‌آنلاین مشتریان', value: 'Qr'},
        // {name: 'سامانه سفارش ودرج تبلیغات اینترنتی', value: 'CRM'},
        // {name: 'سامانه ایمیل مارکتینگ', value: 'googleAds'},
        // {name: 'سامانه تبلیغات در ورزشگاه ونمایشگاه ها', value: 'emailMarket'},
        // {name: 'سامانه جامع مزایده آنلاین', value: 'gyms'},
        // {name: 'سامانه ابزارهای آنلاین کسب وکار', value: 'mozayede'},
        // {name: 'سامانه آموزش آنلاین مشاغل', value: 'freeTools'},
      ],
      pages: [],
    };
  },
  methods: {
    goTo(categoryID, value) {
      this.isActive = value;
      this.getContent(categoryID);
    },
    getPages(id, value) {
      this.activeProject = value;
      Axios2.get(`${this.$coreApi2}/categoryContent?sid=${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("id_token"),
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }).then((res) => {
        console.log(res);
        this.pages = res.data.data;
      });
    },
    getContent(categoryId) {
      Axios2.get(
        `${this.$coreApi2}/categoryTutorial?sid=${this.sid}&category_id=${categoryId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("id_token"),
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        console.log(res);
      });
    },
  },
  mounted() {
    this.getPages(this.sid, this.activeProject);
  },
  computed: {
    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 5;
      }
      if (this.$vuetify.breakpoint.lg) {
        return 5;
      }
      if (this.$vuetify.breakpoint.md) {
        return 5;
      }
      return 1;
    },
  },
};
</script>

<style scoped>
.bg-indigo {
  background-color: #1c0152 !important;
  color: #ffffff;
}

.cardMine {
  border-radius: 15px;
  color: #1c0152;
  background-color: #ffffff;
  box-shadow: 8px 5px 10px #7e8299;
}

.btnStyles {
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 5px 5px 5px #7e8299;
  border: 2px solid #1c0152;
}
.btnActive {
  border-radius: 15px;
  background-color: #ffffff;
  color: #f49d1a;
  box-shadow: 5px 5px 5px #7e8299;
}
.cardStyle {
  border-radius: 15px;
  color: #1c0152;
  background-color: #ffffff;
  box-shadow: 8px 5px 10px #f49d1a;
}

.cardStyle:hover {
  box-shadow: 8px 5px 10px #7e8299;
  background-color: #1c0152;
  color: #ffffff;
}

.cardActive {
  box-shadow: 8px 5px 10px #7e8299 !important;
  background-color: #1c0152 !important;
  color: #f49d1a !important;
}
</style>
